module.exports = __webpack_public_path__ + "static/media/search.bc5f8813.svg";